<template>
  <v-container class="agentes-publicos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          main="Gestão"
          icon="mdi-pencil-box-outline"
          sub="Servidores e agentes públicos"
          home="/gestao-da-camara"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="servidor.usuario"
        />
        <input
          id="servidor-id"
          type="hidden"
          v-model="servidor.id"
        />
        <input
          id="servidor-uuid"
          type="hidden"
          v-model="servidor.uuid"
        />
        <v-row>
          <v-col cols="12" md="8">
            <v-row>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="codigo"
                  label="Código"
                  dense
                  outlined
                >
                  <v-btn
                    class="btn-outer-right pa-0"
                    slot="append"
                    color="success"
                    tile
                    @click.prevent="loadDialog"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="codigo"
              >
                <v-checkbox
                  v-model="servidor.inativar"
                  label="Inativar servidor?"
                  color="success"
                  v-show="mode === 'save'"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
                class="mr-0 pr-0"
              >
                <v-text-field
                  class="codigo mr-0"
                  v-model="servidor.uid_pessoa"
                  label="Código..."
                  dense
                  outlined
                  flat
                  @change="loadPedidoPessoaId()"
                >
                  <v-btn
                    class="btn-outer pa-0"
                    slot="append"
                    color="success"
                    tile
                    @click="loadFtPessoa"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="btn-outer-right pa-0"
                    slot="append"
                    color="light"
                    tile
                    @click="loadAddPessoa"
                  >
                    <v-icon
                      class="mx-0"
                      color="black"
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="mx-0 px-0"
              >
                <v-text-field
                  class="v-busca-nome ml-0"
                  v-model="servidor.agente"
                  :loading="loading"
                  aria-autocomplete="none"
                  :search-input.sync="search"
                  label="Nome"
                  outlined
                  dense
                  @keyup.native="loadSeach()"
                >
                  <v-icon
                    v-if="servidor.agente"
                    slot="append"
                    color="black"
                    @click.prevent="clPessoa"
                  >
                    mdi-close
                  </v-icon>
                </v-text-field>
                <v-card
                  v-show="listar === 'sim'"
                  class="my-0 py-0"
                >
                  <ul class="filtro">
                    <li
                      v-for="item in items"
                      :key="item.id"
                    >
                      <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.agente }}</a>
                    </li>
                  </ul>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="servidor.avatar"
                  label="Avatar"
                  type="text"
                  outlined
                  required
                  dense
                >
                  <v-btn
                    v-if="servidor.avatar"
                    class="btn-outer-left pa-0"
                    slot="append"
                    color="warning"
                    tile
                    @click.prevent="loadDelAvatar()"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                     mdi-delete-outline
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="servidor.thumb"
                  label="Thumbnail"
                  type="text"
                  outlined
                  required
                  dense
                >
                  <v-btn
                    v-if="servidor.thumb"
                    class="btn-outer-left pa-0"
                    slot="append"
                    color="warning"
                    tile
                    @click.prevent="loadDelThumb()"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                     mdi-delete-outline
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="servidor.foto"
                  label="Foto"
                  type="text"
                  outlined
                  required
                  dense
                >
                  <v-btn
                    v-if="servidor.foto"
                    class="btn-outer-left pa-0"
                    slot="append"
                    color="warning"
                    tile
                    @click.prevent="loadDelFoto()"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                     mdi-delete-outline
                    </v-icon>
                  </v-btn>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="5"
              >
                <v-autocomplete
                  v-model="servidor.uid_cargo"
                  :items="cargos"
                  required
                  dense
                  outlined
                  label="Cargo ou função"
                >
                  <v-btn
                    class="btn-outer pa-0"
                    slot="append"
                    color="success"
                    tile
                    @click="loadFtCargo"
                  >
                    <v-icon
                      class="mx-0"
                      color="white"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="btn-outer-right pa-0"
                    slot="append"
                    color="light"
                    tile
                    @click="loadAddCargo"
                  >
                    <v-icon
                      class="mx-0"
                      color="black"
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="7"
              >
                <v-text-field
                  v-model="servidor.nome"
                  type="text"
                  label="Nome comum"
                  outlined
                  dense
                  hint="* Campo obrigatório"
                  persistent-hint
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12">
                <v-card v-if="codigo">
                  <v-img
                    v-if="servidor.avatar"
                    class="pa-2 max-avatar"
                    :src="servidor.avatar">
                  </v-img>
                  <v-img  v-else
                    max-width="100"
                    max-height="80"
                    src="@/assets/icons/person.png">
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card v-if="codigo">
                  <v-img
                    v-if="servidor.thumb"
                    class="pa-2 max-thumb"
                    :src="servidor.thumb">
                  </v-img>
                  <v-img  v-else
                    max-width="150"
                    max-height="115"
                    src="@/assets/icons/person.png">
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card v-if="codigo">
                  <v-img
                    v-if="servidor.foto"
                    class="pa-2"
                    :src="servidor.foto">
                  </v-img>
                  <v-img
                    v-else-if="fotoView"
                    class="pa-2"
                    :src="fotoView">
                  </v-img>
                  <v-img  v-else
                    max-width="340"
                    max-height="255"
                    src="@/assets/icons/person.png">
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab>
              <v-icon class="mr-2">
                mdi-account-card-details
              </v-icon>
              Endereço
            </v-tab>
            <v-tab @click="loadTbFones">
              <v-icon class="mr-2">
                mdi-phone
              </v-icon>
              Telefones
            </v-tab>
            <v-tab @click="loadTbRedes">
              <v-icon class="mr-2">
                mdi-chat-plus-outline
              </v-icon>
              Redes sociais
            </v-tab>
            <v-tab @click="loadTbEmails">
              <v-icon class="mr-2">
                mdi-account
              </v-icon>
              E-mails
            </v-tab>
            <v-tab @click="loadTbPerfis">
              <v-icon class="mr-2">
                mdi-text-account
              </v-icon>
              Sobre
            </v-tab>
            <v-tab v-if="servidor.uid_gestao" @click="loadTbFotos">
              <v-icon class="mr-2">
                mdi-camera
              </v-icon>
              Fotos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card
                flat
                class="mt-2"
              >
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="servidor.end_correspondencia"
                      name="endereco"
                      label="Endereço para correspondência"
                      :counter="1000"
                      dense
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Telefones
                      </v-card-title>
                      <v-data-table
                        :headers="headersTelefone"
                        :items="telefones"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadTelefone(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadTelefone(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarTelefone"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar telefone
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Redes sociais
                      </v-card-title>
                      <v-data-table
                        :headers="headersRedes"
                        :items="redes"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadRede(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadRede(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarRedes"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar rede social
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        E-mails
                      </v-card-title>
                      <v-data-table
                        :headers="headersEmail"
                        :items="emails"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadEmail(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadEmail(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="adicionarEmail"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar e-mail
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Informações adicionais
                      </v-card-title>
                      <v-data-table
                        :headers="headersPerfil"
                        :items="perfis"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadPerfil(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadPerfil(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          v-if="codigo"
                          cols="12"
                          md="4"
                        >
                          <v-btn
                            color="success"
                            class="ml-2 mb-2"
                            v-if="btn"
                            @click="loadAddPerfil()"
                          >
                            <v-icon left>
                              mdi-text-account
                            </v-icon>
                            Adicionar perfil
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="mb-2">
                      <v-card-title>
                        Fotos
                      </v-card-title>
                      <v-data-table
                        :headers="headersFoto"
                        :items="fotos"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            v-if="fotoView"
                            class="m2-2"
                            color="success"
                            @click="loadAddImg(item)"
                            >
                            mdi-upload-outline
                          </v-icon>
                          <v-icon
                            v-if="!fotoView"
                            medium
                            color="success"
                            class="mr-2"
                            @click="verFoto(item)"
                          >
                            mdi-eye-outline
                          </v-icon>
                          <v-icon
                            v-if="fotoView"
                            medium
                            color="error"
                            class="mr-2"
                            @click="closeFoto()"
                          >
                          mdi-eye-off
                          </v-icon>
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadFoto(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadFoto(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="codigo"
                            @click="loadAddFoto"
                          >
                            <v-icon left>
                              mdi-camera
                            </v-icon>
                            Adicionar Foto
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="servidores"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadAgPerfil(item, 'addPerfil')"
                    >
                      mdi-text-account
                    </v-icon>
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadServidor(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadServidor(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addImg"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Vincular imagem ao agente</v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="uid_agente"
                  type="hidden"
                  v-model="image.uid_agente"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="tpImage"
                      :items="tImage"
                      required
                      dense
                      outlined
                      @change="upCampo()"
                      label="Tipo de imagem"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="image.id">
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="image.url_foto"
                      label="url da foto ou imagem:"
                      class="mb-2"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="image.id"
                type="submit"
                @click.prevent="saveImage()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click.prevent="closeAddImg"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addfoto"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Adicionar e editar Foto</v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="foto.usuario"
                />
                <input
                  id="foto-id"
                  type="hidden"
                  v-model="foto.id"
                />
                <input
                  id="foto-uuid"
                  type="hidden"
                  v-model="foto.uuid"
                />
                <input
                  id="uid_agente"
                  type="hidden"
                  v-model="foto.uuid_pessoa"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="codigo"
                  >
                    <v-checkbox
                      v-model="foto.inativar"
                      label="Inativar Foto?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="codigo"
                  >
                    <v-checkbox
                      v-model="foto.publico_privado"
                      label="Foto pública ?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="dtp"
                              v-model="data_publicacao"
                              label="Data de publicação.:"
                              dense
                              outlined
                              @blur="mudaDataMidia"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                </v-row>
                <v-row v-if="foto.id">
                  <v-col
                    cols="12"
                    lg="8"
                  >
                    <v-text-field
                      v-model="foto.nome_foto"
                      label="Nome da foto ou imagem:"
                      class="mb-2"
                      :readonly="mode === 'remove'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="foto.id">
                  <v-col
                    cols="12"
                    lg="8"
                  >
                    <v-text-field
                      v-model="foto.url_foto"
                      label="Link da foto ou imagem :"
                      class="mb-2"
                      :readonly="mode === 'remove'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="!foto.id">
                  <input
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera"
                    label="Foto do agente"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="foto.id"
                type="submit"
                @click.prevent="saveFoto()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!foto.id"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Upload
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="!foto.id"
                @click="clearUpload"
              >
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click.prevent="closeAddFoto"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addPerfil"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Sobre o servidor</v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="perfil.usuario"
                  />
                  <input
                    id="perfil-id"
                    type="hidden"
                    v-model="perfil.id"
                  />
                  <input
                    id="uid_agente"
                    type="hidden"
                    v-model="perfil.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="perfil.inativar"
                        label="Inativar perfil ?"
                        color="success"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="perfil.privado"
                        label="Tornar perfil privado?"
                        color="success"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="perfil.titulo"
                        label="Título ou Nome"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card class="pa-2">
                        <ckeditor
                          class="altura"
                          :editor="editor"
                          v-model="perfil.perfil"
                          :config="editorConfig"
                          placeholder="Biografia...">
                        </ckeditor>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="adicionarSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="limpar"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addTelefone"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar telefones
              </v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="telefone.usuario"
                  />
                  <input
                    id="telefone-id"
                    type="hidden"
                    v-model="telefone.id"
                  />
                  <input
                    id="telefone-uuid"
                    type="hidden"
                    v-model="telefone.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.uid_tipo"
                        :items="tipofone"
                        required
                        dense
                        outlined
                        label="Tipo de telefone"
                        @change="loadFuncaoFone()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="telefone.fone"
                        v-mask='msFone'
                        label="Telefone"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-checkbox
                        v-model="telefone.privado"
                        label="Tornar privado ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      lg="2"
                    >
                      <v-checkbox
                        v-model="telefone.whats"
                        label="WhatsApp ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="!telefone.id"
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="telefone.data_cadastro"
                        v-mask='dtcad'
                        label="Data do cadastro"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.icon"
                        :items="iconFone"
                        clearable
                        dense
                        outlined
                        label="Ícone p/ telefone"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-autocomplete
                        v-model="telefone.color"
                        :items="colors"
                        required
                        dense
                        outlined
                        label="Cor do ícone"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="11"
                      md="11"
                    >
                      <v-textarea
                        v-model="telefone.ds_fone"
                        name="historico"
                        label="Observação"
                        :counter="5000"
                        dense
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="telefone.id"
                  type="submit"
                  @click="updateFone"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!telefone.id"
                  type="submit"
                  @click="adicionarFone"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!telefone.id"
                  type="submit"
                  @click="adicionarFoneSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar e sair
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!telefone.id"
                  @click="limparFone"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addRedes"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar redes sociais
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="rede.usuario"
                />
                <input
                  id="telefone-id"
                  type="hidden"
                  v-model="rede.id"
                />
                <input
                  id="telefone-uuid"
                  type="hidden"
                  v-model="rede.uid_pessoa"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-text-field
                      v-model="rede.social"
                      label="Rede social"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-autocomplete
                      v-model="rede.icon"
                      :items="icons"
                      required
                      dense
                      outlined
                      label="Ícone da rede"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-checkbox
                      v-model="rede.privado"
                      label="Tornar privada ?"
                      color="success"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-if="!rede.id"
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-text-field
                      v-model="rede.data_cadastro"
                      v-mask='dtcad'
                      label="Data do cadastro"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                  >
                    <v-autocomplete
                      v-model="rede.color"
                      :items="colors"
                      required
                      dense
                      outlined
                      label="Cor do ícone"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="11"
                    md="11"
                  >
                    <v-text-field
                      v-model="rede.url_social"
                      name="url"
                      label="Url completa"
                      required
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="rede.id"
                type="submit"
                @click="updateRede"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!rede.id"
                type="submit"
                @click="adicionarRede"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!rede.id"
                type="submit"
                @click="adicionarRedeSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="!rede.id"
                @click="limparRede"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="limparSair"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog cadastro de pessoa -->
      <v-container>
        <v-dialog
          v-model="DialogPessoa"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar interessado
            </v-toolbar>
            <v-form ref="form">
              <Cadastro :btnsair="btnsair" />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="FecharDialog"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog cadastro de cargos e funções -->
      <v-container>
        <v-dialog
          v-model="dialogCargo"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar cargos e funções
            </v-toolbar>
            <v-form ref="form">
              <Cargos />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="closeDialog"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addEmail"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar E-mails
              </v-toolbar>
              <div class="ml-4 mt-5">
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="email.usuario"
                  />
                  <input
                    id="email-id"
                    type="hidden"
                    v-model="email.id"
                  />
                  <input
                    id="email-uuid"
                    type="hidden"
                    v-model="email.uid_pessoa"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-text-field
                        v-model="email.email"
                        label="E-mail"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-model="email.principal"
                        label="Principal ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-checkbox
                        v-model="email.privado"
                        label="E-mail privado ?"
                        color="success"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="!email.id"
                      cols="12"
                      md="4"
                      lg="3"
                    >
                      <v-text-field
                        v-model="email.data_cadastro"
                        v-mask='dtcad'
                        label="Data do cadastro"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="11"
                      md="11"
                    >
                      <v-textarea
                        v-model="email.ds_email"
                        name="historico"
                        label="Observação"
                        :counter="5000"
                        dense
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-center">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="email.id"
                  type="submit"
                  @click="updateEmail"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!email.id"
                  type="submit"
                  @click="adicionarEmailSave"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="!email.id"
                  type="submit"
                  @click="adicionarEmailSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Adicionar e sair
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="!email.id"
                  @click="limparEmail"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '@/modules/admin/cadastros/pessoas'
import Cargos from '@/modules/cadastros/components/cargos'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
// import { VueEditor } from 'vue2-editor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'EstruturaOrganizacional',
  components: { PageTitle, Cadastro, Cargos },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    editor: ClassicEditor,
    editorConfig: {},
    tabs: null,
    btn: false,
    dtp: '##/##/####',
    dtcad: '##/##/####',
    mcel: '(##)#####-####',
    mres: '(##)####-####',
    msFone: '',
    codigo: '',
    dialog: false,
    fotoView: null,
    DialogPessoa: false,
    dialogCargo: false,
    addfoto: false,
    addImg: false,
    addTelefone: false,
    addRedes: false,
    addEmail: false,
    addPerfil: false,
    uploadReady: true,
    btnsair: true,
    loading: false,
    search: null,
    select: null,
    file: '',
    date: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    tabela: 'fotos',
    pasta: 'perfilAgentes',
    mode: 'save',
    fotouuid: '',
    fotousuario: '',
    listar: '',
    servidor: {},
    perfil: {},
    email: {},
    telefone: {},
    image: {},
    imagem: {},
    foto: {},
    capa: {},
    rede: {},
    pessoa: {},
    redes: [],
    pessoas: [],
    items: [],
    emails: [],
    telefones: [],
    fotos: [],
    cargos: [],
    imagens: {},
    perfis: [],
    servidores: [],
    length: '',
    tpImage: '',
    imodel: '',
    tipofone: [],
    tImage: [
      { value: 'avatar', text: 'Avatar' },
      { value: 'thumb', text: 'Thumbnail' },
      { value: 'foto', text: 'Foto' }
    ],
    iconFone: [
      { value: 'mdi-whatsapp', text: 'WhatsApp' },
      { value: 'mdi-cellphone', text: 'Celular' },
      { value: 'mdi-phone', text: 'Telefone' }
    ],
    icons: [
      { value: 'mdi-facebook', text: 'Facebook' },
      { value: 'mdi-linkedin', text: 'Linkedin' },
      { value: 'mdi-instagram', text: 'Instagram' }
    ],
    colors: [
      { value: 'indigo', text: 'Roxo' },
      { value: 'teal darken-3', text: 'Verde' },
      { value: 'grey darken-4', text: 'Preto' },
      { value: 'red lighten-3', text: 'Vermelho' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'agente' },
      { text: 'Cpf', value: 'cpf' },
      { text: 'Telefone', value: 'fone' },
      { text: 'Celular', value: 'celular' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersPerfil: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Data de inclusão', value: 'dt_inc', sortable: false },
      { text: 'Última atualização', value: 'dt_up', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersTelefone: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Telefone', value: 'fone' },
      { text: 'Tipo', value: 'tipo' },
      {
        text: 'Privado ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersRedes: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Rede', value: 'social' },
      { text: 'Url', value: 'url' },
      {
        text: 'Privada ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersEmail: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'E-mail', value: 'email' },
      {
        text: 'Principal ?',
        value: 'principal',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Privado ?',
        value: 'privado',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersFoto: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url_foto' },
      { text: 'Tam Arq.', value: 'size_foto' },
      { text: 'Data', value: 'data_publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ]
  }),
  methods: {
    upCampo () {
      const tipo = this.tpImage
      if (tipo === 'avatar') {
        this.imagem.avatar = this.image.url_foto
      }
      if (tipo === 'thumb') {
        this.imagem.thumb = this.image.url_foto
      }
      if (tipo === 'foto') {
        this.imagem.foto = this.image.url_foto
      }
    },
    endereco () {

    },
    fone () {

    },
    histori () {

    },
    validate () {
      this.$refs.form.validate()
    },

    dateF () {
      this.data_publicacao = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },

    save () {
      const method = this.servidor.id ? 'put' : 'post'
      const id = this.servidor.id ? `/${this.servidor.id}` : ''
      axios[method](`${baseApiUrl}/servidores${id}`, this.servidor)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    savePerfil () {
      const method = this.perfil.id ? 'put' : 'post'
      const id = this.perfil.id ? `/${this.perfil.id}` : ''
      axios[method](`${baseApiUrl}/perfil-de-pessoas${id}`, this.perfil)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadPerfis()
        })
        .catch(showError)
    },
    saveFone () {
      const method = this.telefone.id ? 'put' : 'post'
      const id = this.telefone.id ? `/${this.telefone.id}` : ''
      axios[method](`${baseApiUrl}/telefone-de-pessoas${id}`, this.telefone)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparFone()
          this.loadTelefones()
        })
        .catch(showError)
    },
    saveRede () {
      const method = this.rede.id ? 'put' : 'post'
      const id = this.rede.id ? `/${this.rede.id}` : ''
      axios[method](`${baseApiUrl}/rede-social-de-pessoas${id}`, this.rede)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparRede()
          this.loadRedes()
        })
        .catch(showError)
    },
    saveEmail () {
      const method = this.email.id ? 'put' : 'post'
      const id = this.email.id ? `/${this.email.id}` : ''
      axios[method](`${baseApiUrl}/email-de-pessoas${id}`, this.email)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparEmail()
          this.loadEmails()
        })
        .catch(showError)
    },
    saveFoto () {
      const method = this.foto.id ? 'put' : 'post'
      const id = this.foto.id ? `/${this.foto.id}` : ''
      axios[method](`${baseApiUrl}/foto-de-pessoa${id}`, this.foto)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparFoto()
          this.loadFotos()
          this.addfoto = false
        })
        .catch(showError)
    },
    saveImage () {
      const method = this.codigo ? 'put' : 'post'
      const id = this.codigo ? `/${this.codigo}` : ''
      axios[method](`${baseApiUrl}/servidores${id}`, this.imagem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.closeAddFoto()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadDelAvatar () {
      this.capa.avatar = ''
      const id = this.servidor.id
      axios.put(`${baseApiUrl}/remove-foto-servidor/${id}`, this.capa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.updateServidor()
        })
        .catch(showError)
    },
    loadDelThumb () {
      this.capa.thumb = ''
      const id = this.servidor.id
      axios.put(`${baseApiUrl}/remove-foto-servidor/${id}`, this.capa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.updateServidor()
        })
        .catch(showError)
    },
    loadDelFoto () {
      this.capa.foto = ''
      const id = this.servidor.id
      axios.put(`${baseApiUrl}/remove-foto-servidor/${id}`, this.capa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.updateServidor()
        })
        .catch(showError)
    },
    verFoto (item) {
      this.fotoView = item.url_foto
    },
    closeFoto () {
      this.fotoView = null
    },
    loadTipoFone () {
      const url = `${baseApiUrl}/tipo-de-telefones`
      axios.get(url).then(res => {
        this.tipofone = res.data.map(tipofone => {
          return {
            value: tipofone.id,
            text: `${tipofone.tipo}`
          }
        })
      })
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/foto-pessoas-upload`
      formData.append('uuid', this.fotouuid)
      formData.append('uuid_pessoa', this.pessoas.uuid)
      formData.append('uid_pessoa', this.pessoas.id)
      formData.append('data_publicacao', this.date)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('usuario', this.fotousuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    loadServidores () {
      const url = `${baseApiUrl}/servidores`
      axios.get(url).then(res => {
        this.servidores = res.data
      })
    },
    FecharDialog () {
      this.DialogPessoa = false
    },
    loadPerfis () {
      const idV = this.pessoas.id
      const url = `${baseApiUrl}/perfil-da-pessoa/${idV}`
      axios.get(url).then(res => {
        this.perfis = res.data.map(item => {
          return {
            ...item,
            dt_inc: moment(item.created_at).format('DD/MM/YYYY'),
            dt_up: moment(item.updated_at).format('DD/MM/YYYY')
          }
        })
        const hs = this.perfis
        if (hs.length === 0) {
          this.btn = true
        }
      })
    },
    loadTelefones () {
      const idF = this.pessoas.id
      const url = `${baseApiUrl}/fone-de-pessoas-por-usuario/${idF}`
      axios.get(url).then(res => {
        this.telefones = res.data
      })
    },
    loadRedes () {
      const idF = this.pessoas.id
      const url = `${baseApiUrl}/rede-social-de-pessoas-por-usuario/${idF}`
      axios.get(url).then(res => {
        this.redes = res.data
      })
    },
    loadEmails () {
      const idE = this.pessoas.id
      const url = `${baseApiUrl}/email-de-pessoas-por-usuario/${idE}`
      axios.get(url).then(res => {
        this.emails = res.data
      })
    },
    loadFotos () {
      const idP = this.pessoas.uuid
      const url = `${baseApiUrl}/foto-por-pessoa/${idP}`
      axios.get(url).then(res => {
        this.fotos = res.data
      })
    },
    updateServidor () {
      const codId = this.codigo
      const url = `${baseApiUrl}/servidores-update/${codId}`
      axios.get(url).then(res => {
        this.servidor = res.data
        this.codigo = this.servidor.id
        const cdimg = this.servidor.uid_pessoa
        this.dialog = false
        this.loadPessoaId(cdimg)
      })
    },
    loadServidor (item) {
      const codId = item.id
      const url = `${baseApiUrl}/servidores-update/${codId}`
      axios.get(url).then(res => {
        this.servidor = res.data
        this.codigo = this.servidor.id
        const cdimg = this.servidor.uid_pessoa
        this.dialog = false
        this.loadPessoaId(cdimg)
      })
    },
    loadTelefone (items, mode = 'save') {
      this.mode = mode
      const id = items.id
      const url = `${baseApiUrl}/telefone-update/${id}`
      axios.get(url).then(res => {
        this.telefone = res.data
      })
      this.loadTipoFone()
      this.addTelefone = true
    },
    loadEmail (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/email-update/${id}`
      axios.get(url).then(res => {
        this.email = res.data
      })
      this.mode = mode
      this.addEmail = true
    },
    loadRede (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/rede-social-de-pessoas-up/${id}`
      axios.get(url).then(res => {
        this.rede = res.data
      })
      this.mode = mode
      this.addRedes = true
    },
    loadFoto (items, mode = 'save') {
      const id = items.id
      const url = `${baseApiUrl}/fotos-de-pessoas-up/${id}`
      axios.get(url).then(res => {
        this.foto = res.data
      })
      this.mode = mode
      this.addfoto = true
    },
    loadAgPerfil (servidor, mode = 'addPerfil') {
      this.mode = mode
      this.servidor = { ...servidor }
      this.codigo = servidor.id
      const cod = servidor.uid_pessoa
      this.dialog = false
      this.loadPessoaId(cod)
    },
    loadAddPerfil () {
      this.perfil.uid_pessoa = this.pessoas.id
      this.perfil.usuario = this.user.id
      this.addPerfil = true
    },
    loadPedidoPessoaId (item) {
      const id = this.servidor.uid_pessoa ? `/${this.servidor.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/servidores-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.servidor.uid_pessoa = this.pessoa.uid_pessoa
        this.servidor.agente = this.pessoa.agente
        this.servidor.cpf = this.pessoa.cpf
        this.servidor.cpf_txt = this.pessoa.cpf_txt
      })
      this.clPessoa()
    },
    loadPessoaId (cod) {
      const id = cod
      const url = `${baseApiUrl}/adm-adm-pessoas-por-id/${id}`
      axios.get(url).then(res => {
        this.pessoas = res.data
      })
      this.btn = false
    },
    clPessoa () {
      this.servidor.uid_pessoa = ''
      this.servidor.agente = ''
      this.servidor.cpf = ''
      this.servidor.cpf_txt = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.servidor.agente || 0
      const url = `${baseApiUrl}/servidores-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {
      this.assunto = {}
      this.DialogPessoa = true
    },
    loadFtCargo () {

    },
    loadAddCargo () {
      this.dialogCargo = true
    },
    closeDialog () {
      this.dialogCargo = false
      this.loadCargos()
    },
    loadPerfil (items, mode = 'save') {
      const idV = items.id
      const url = `${baseApiUrl}/perfil-da-pessoa-for-up/${idV}`
      axios.get(url).then(res => {
        this.perfil = res.data
      })
      this.mode = mode
      this.addPerfil = true
    },
    loadTbFones () {
      this.loadTelefones()
    },
    loadTbRedes () {
      this.loadRedes()
    },
    loadTbEmails () {
      this.loadEmails()
    },
    loadTbPerfis () {
      this.loadPerfis()
    },
    loadTbFotos () {
      this.loadFotos()
    },
    adicionarTelefone () {
      this.loadTipoFone()
      this.telefone.usuario = this.user.id
      this.telefone.uid_pessoa = this.pessoas.id
      this.addTelefone = true
    },
    adicionarRedes () {
      this.rede.usuario = this.user.id
      this.rede.uid_pessoa = this.pessoas.id
      this.addRedes = true
    },
    adicionarEmail () {
      this.email.usuario = this.user.id
      this.email.uid_pessoa = this.pessoas.id
      this.addEmail = true
    },
    loadFuncaoFone () {
      let tp = this.telefone.uid_tipo
      if (tp === 1) {
        this.msFone = this.mcel
      } else if (tp === 2) {
        this.msFone = this.mres
      }
    },
    reset () {
      this.valid = false
      this.btn = false
      this.codigo = ''
      this.mode = 'save'
      this.pessoas = []
      this.servidores = []
      this.servidor = {}
      this.perfis = []
      this.telefones = []
      this.redes = []
      this.emails = []
    },
    limpar () {
      this.valid = false
      this.mode = 'save'
      this.perfil = {}
    },
    limparFone () {
      this.mode = 'save'
      this.telefone = {}
    },
    limparRede () {
      this.mode = 'save'
      this.rede = {}
    },
    limparSair () {
      this.mode = 'save'
      this.rede = {}
      this.addRedes = false
    },
    limparEmail () {
      this.mode = 'save'
      this.email = {}
    },
    limparFoto () {
      this.mode = 'save'
      this.foto = {}
    },
    closeAddFoto () {
      this.foto = {}
      this.addfoto = false
    },
    closeAddImg () {
      this.image = {}
      this.addImg = false
    },
    adicionarSair () {
      this.savePerfil()
      this.addPerfil = false
    },
    adicionarFone () {
      this.saveFone()
    },
    adicionarFoneSair () {
      this.saveFone()
      this.addTelefone = false
    },
    updateFone () {
      this.saveFone()
      this.addTelefone = false
    },
    adicionarRede () {
      this.saveRede()
    },
    adicionarRedeSair () {
      this.saveRede()
      this.addRedes = false
    },
    updateRede () {
      this.saveRede()
      this.addRedes = false
    },
    adicionarEmailSave () {
      this.saveEmail()
    },
    adicionarEmailSair () {
      this.saveEmail()
      this.addEmail = false
    },
    updateEmail () {
      this.saveEmail()
      this.addEmail = false
    },
    loadDialog () {
      this.dialog = true
      this.loadServidores()
    },
    loadAddFoto () {
      this.fotouuid = uuid.v1()
      this.fotousuario = this.user.id
      this.addfoto = true
    },
    loadAddImg (item) {
      this.image = { ...item }
      this.addImg = true
    },
    addImagens (item) {
      const id = this.servidor.id
      this.imagens.avatar = item.url_foto
      axios.put(`${baseApiUrl}/servidores/${id}`, this.imagens)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.updateServidor()
        })
        .catch(showError)
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(cargos => {
          return {
            value: cargos.id,
            text: `${cargos.cargo}`
          }
        })
      })
    },
    loadUser () {
      this.servidor.usuario = this.user.id
      this.servidor.uuid = uuid.v1()
    }
  },
  mounted () {
    this.loadUser()
    this.loadCargos()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-left {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
.max-avatar {
  max-width: 100px;
}
.max-thumb {
  max-width: 180px;
}
</style>
